// extracted by mini-css-extract-plugin
export const card = "Card-module--card--YaLCA";
export const cover = "Card-module--cover--3eGyd";
export const tag = "Card-module--tag--2yl5g";
export const mission = "Card-module--mission--366SZ";
export const component = "Card-module--component--2xdI7";
export const horizontal = "Card-module--horizontal--EXflT";
export const vertical = "Card-module--vertical--459vP";